   <template>
  <div class="detail_attributes_content">
    <div
      class="detail_attributes_items"
      v-if="CartItemOpt.ProductAttributeOpt.length > 0"
    >
      <div
        class="detail_attributes_name"
        v-for="item in CartItemOpt.ProductAttributeOpt"
        :key="item.Id"
      >
        1 * {{ item.Name }} {{ CartItemOpt.PriceFormat }}
      </div>
    </div>
    <div
      class="detail_params_items"
      v-if="CartItemOpt.ProductRemarkItemsOpt.length > 0"
    >
      <div
        class="detail_params_name"
        v-for="item in CartItemOpt.ProductRemarkItemsOpt"
        :key="item.Id"
      >
        <div>1 * {{ item.Name }} {{ item.PriceFormat }}</div>
        <van-icon name="delete-o" @click="DeleteRemark(item)" size="18" />
      </div>
    </div>
    <div
      v-if="
        CartItemOpt.ProductAttributeOpt.length == 0 &&
        CartItemOpt.ProductRemarkItemsOpt.length == 0
      "
      class="detail_attributes_notitems"
    ></div>
  </div>
</template>
<script >
import axios from "../commons/AxiosMethod.js";
import tools from "../commons/tools.js";
import commons from "../commons/commons.js";
import { showToast } from "vant";

export default {
  data() {
    return {
      index: 0,
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      tools: tools,
      DetailOrderWindow: false, // 详细信息页面
      CartItemOpt: {
        ProductAttributeOpt: [],
        ProductRemarkItemsOpt: [],
      }, // 选中购物车项目
      UpdateProduct: () => {},

      UserInfo: {}, // 用户信息
    };
  },

  name: "App",
  mounted() {
    this.CartItemOpt={
      ProductRemarkItemsOpt:[]
    };
    this.UpdateProduct = this.update;
    this.CartItemOpt = this.Model;
  },
  props: {
    Model: {},
    update: null,
  },
  components: {},
 
  methods: {
    DeleteRemark(item) {
      axios.apiMethod(
        "/Store/StoreOrder/DeleteRemarks",
        "get",
        { shoppingCartId: this.CartItemOpt.Id, remarkId: item.Id },
        (result) => {
          if (result.Data.IsSuccess) {
            this.$emit("update", "")
          } else {
            showToast(result.Data.Msg);
          }
        },
        (e) => {}
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.detail_attributes_content {
width: 100%; 
  .detail_attributes_items,
  .detail_params_items {
    width: calc(100% - 50px);
    margin: 0 auto;
    border-radius: 5px;
width: 100%;
  margin: 5px;
    .detail_attributes_name,
    .detail_params_name { 
      width: calc(100% - 70px);
      margin-left: 35px;
      font-size: 9pt;
      display: flex;
      justify-content: space-between;
      color: #807f7f;
    }
  }
  .detail_attributes_notitems {
    width: 100%;
    text-align: center;
  }
}

.content {
  .content_item {
    .content_item_title {
      width: calc(100% - 100px);
      margin-left: 20px;
      font-size: 15pt;
    }
  }
}
</style>
